import { ChangeEvent } from 'react';
import { Select } from '../atoms/Inputs/Select';

export interface SelectReferralSourceProps {
	testId?: string;
	value: string;
	onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
	label: string;
}

const SelectReferralSource = (props: SelectReferralSourceProps) => {
	const { testId = 'SelectReferralSource', value, onChange, label } = props;

	return (
		<Select
			testId={testId}
			id="referralSource"
			name="referralSource"
			label={label}
			value={value}
			onChange={onChange}
		>
			<option></option>
			<option value="Google/Bing/DuckDuckGo">Google/Bing/DuckDuckGo</option>
			<option value="Blog/Article">Blog/Article</option>
			<option value="Social Network">Social Network</option>
			<option value="Friend/Word of Mouth">Friend/Word of Mouth</option>
			<option value="ChatGPT/Gemini/Perplexity/AI Tool">
				ChatGPT/Gemini/Perplexity/AI Tool
			</option>
			<option value="Reddit">Reddit</option>
			<option value="Other/Not Listed">Other/Not Listed</option>
		</Select>
	);
};

export default SelectReferralSource;
